export default "__VITE_ASSET__2cKohDQt__"